import { queryOptions, keepPreviousData } from '@tanstack/react-query';
import { legacyProfileApi, type LegacyStatsQuery } from './legacy-profile-api';

export const legacyProfileKeys = {
  all: ['legacy-profile'] as const,
  // The week start participates in the key so the count re-fetches across a
  // week boundary, as the old shell's `["profileData", weekStart]` key did.
  me: (newClientsFrom?: string) =>
    [...legacyProfileKeys.all, 'me', newClientsFrom ?? null] as const,
  stats: (query: LegacyStatsQuery) => [...legacyProfileKeys.all, 'stats', query] as const,
  pricing: () => [...legacyProfileKeys.all, 'pricing'] as const,
  ratings: (query?: { limit?: number; skip?: number }) =>
    [...legacyProfileKeys.all, 'ratings', query ?? null] as const,
  cards: () => [...legacyProfileKeys.all, 'cards'] as const,
  invoices: (query: { limit: number; skip: number }) =>
    [...legacyProfileKeys.all, 'invoices', query] as const,
};

export const legacyProfileQueries = {
  me: (query?: { newClientsFrom?: string }) =>
    queryOptions({
      queryKey: legacyProfileKeys.me(query?.newClientsFrom),
      queryFn: () => legacyProfileApi.me(query),
    }),
  stats: (query: LegacyStatsQuery) =>
    queryOptions({
      queryKey: legacyProfileKeys.stats(query),
      queryFn: () => legacyProfileApi.stats(query),
    }),
  pricing: () =>
    queryOptions({
      queryKey: legacyProfileKeys.pricing(),
      queryFn: () => legacyProfileApi.pricing(),
    }),
  ratings: (query?: { limit?: number; skip?: number }) =>
    queryOptions({
      queryKey: legacyProfileKeys.ratings(query),
      queryFn: () => legacyProfileApi.ratings(query),
      // The old page kept its rows up while paging — the table never blanked
      // between `skip` windows.
      placeholderData: keepPreviousData,
    }),
  cards: () =>
    queryOptions({
      queryKey: legacyProfileKeys.cards(),
      queryFn: () => legacyProfileApi.cards(),
    }),
  invoices: (query: { limit: number; skip: number }) =>
    queryOptions({
      queryKey: legacyProfileKeys.invoices(query),
      queryFn: () => legacyProfileApi.invoices(query),
    }),
};
